"use client";

import { useContext } from "react";
import { CartContext } from "@/global-store/cart-data";
import { Typography } from "../typography";

const CartCount = () => {
  const { cartData } = useContext(CartContext);

  const count = cartData.reduce((acc, { quantity }) => acc + quantity, 0);

  return cartData.length ? (
    <span className="bg-white rounded-full w-4 h-4 text-xs flex items-center justify-center absolute top-0 right-0 -mt-[1px] -mr-[1px]">
      <Typography tag="span" className="text-gray-bg5 font-semibold">
        {count}
      </Typography>
    </span>
  ) : null;
};

export default CartCount;
